export default __webpack_public_path__ + "static/media/AvenirRomanFont.91a3b972.otf";